import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import InvoiceStatusBadge from '../../components/InvoiceStatus/InvoiceStatusBadge';
import List from '../../components/Crud/List';
import { useAuth } from '../../contexts/auth';
import InvoiceStatusState, { isEditable } from '../../enums/InvoiceStatusState';

export type InvoiceStatusModel = {
  id: number;
  label: string;
  state: InvoiceStatusState;
};

export default function InvoiceStatusesIndex() {
  const [isLoading, setIsLoading] = useState(true);
  const [invoiceStatuses, setInvoiceStatuses] = useState(
    [] as InvoiceStatusModel[]
  );

  const {
    user: { organization },
  } = useAuth();

  async function getInvoiceStatuses() {
    if (organization) {
      setIsLoading(true);
      const response = await api.get(
        `organizations/${organization.id}/invoice-statuses`
      );
      setInvoiceStatuses(response.data.data);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getInvoiceStatuses();
  }, [organization]);

  return (
    <List isLoading={isLoading} title='Situações de OS' newItemUrl='new'>
      <table className='table table-hover'>
        <thead>
          <tr>
            <th scope='col'>#</th>
            <th scope='col'>Nome</th>
            <th scope='col'>Status</th>
          </tr>
        </thead>
        <tbody>
          {invoiceStatuses.map((i) => {
            return (
              <tr key={i.id}>
                <th scope='row'>{i.id}</th>
                <td>
                  {isEditable(i.state) ? (
                    <Link to={`${i.id}/edit`}>{i.label}</Link>
                  ) : (
                    i.label
                  )}
                </td>
                <td>
                  <InvoiceStatusBadge state={i.state} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </List>
  );
}
